import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Be1Repository } from '@/core/repositories/be1/be1-repository';
import { CardInfo, CreateUserPayload, UserEntity, UserListItem } from '@/features/user/models/user';

interface IsExistResponse {
    status: 'EXIST' | 'NOT_EXIST';
}

@Injectable({
    providedIn: 'root'
})
export class UserRepository extends Be1Repository<UserEntity, UserEntity> {
    constructor(http: HttpClient) {
        super(http, 'user');
    }

    search(term: string, fields: string[] = ['fname', 'lname', 'email', 'mobile']): Observable<UserListItem[]> {
        return this.http.get<UserListItem[]>(`${this.entityUrl}/search`, {
            params: { term, fields }
        });
    }

    createUser(payload: CreateUserPayload): Observable<UserEntity> {
        return this.http.post<any>(this.entityUrl, payload).pipe(this.mapSingle());
    }

    isEmailNotExist(email: string): Observable<boolean> {
        return this.http
            .get<IsExistResponse>(`${this.baseURL}/api/account/email/check`, { params: { email } })
            .pipe(map((res) => res.status === 'NOT_EXIST'));
    }

    isMobileNotExist(isoCode: string, mobile: string): Observable<boolean> {
        return this.http
            .get<IsExistResponse>(`${this.baseURL}/api/account/mobile/check`, { params: { isoCode, mobile } })
            .pipe(map((res) => res.status === 'NOT_EXIST'));
    }

    setPassword(userId: string, newPassword: string): Observable<void> {
        return this.http.put<void>(`${this.entityUrl}/${userId}/password`, { newPassword });
    }

    updateCardInfo(userId: string, cards: CardInfo[]): Observable<void> {
        return this.http.put<void>(`${this.entityUrl}/${userId}/cardInfo`, cards);
    }

    upgradeFamilyLevel(userId: string, level: 'GOLFDIGG' | 'GOLD' | 'BLACK'): Observable<void> {
        return this.http.post<void>(`${this.entityUrl}/${userId}/setLevel`, { level });
    }

    sendSMS(userId: string, channel: 'NOTIFY' | 'SMS', message: string, mobile: string): Observable<void> {
        return this.http.post<void>(`${this.entityUrl}/${userId}/notify`, { channel, message, mobile });
    }
}
